import React from "react";
import {TableButton} from "./TableButton";

export const EditButton = ({row}) => {
    return (<TableButton href={'form/' + row.original.id} variant="primary" title="Editar">
            <i className="fas fa-pencil-alt" aria-hidden="true"></i>
        </TableButton>
    )
}
